var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCurvedArrowDown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 158,
    viewBox: "0 0 15 158",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.4459 157.832C8.90565 158.138 9.52643 158.014 9.83245 157.554L14.8194 150.062C15.1254 149.602 15.0008 148.982 14.541 148.676C14.0813 148.369 13.4605 148.494 13.1545 148.954L8.72165 155.613L2.06205 151.181C1.6023 150.875 0.981525 150.999 0.675504 151.459C0.369482 151.919 0.494103 152.54 0.953853 152.846L8.4459 157.832ZM8.01162 0.848021C3.47794 30.3324 -2.88162 102.894 8.01956 157.197L9.98044 156.803C-0.851534 102.845 5.46658 30.5591 9.98838 1.15198L8.01162 0.848021Z",
    fill: "#009653"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurvedArrowDown);
export default __webpack_public_path__ + "static/media/CurvedArrowDown.1dd7edff1a7fb5984d3b5d85e723abe7.svg";
export { ForwardRef as ReactComponent };